import React, { forwardRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Avatar } from "@material-ui/core";
import { FaFilePdf } from "react-icons/fa";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { SummaryCard } from "../../../components/StyledComponent";
import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import { useForm } from "react-hook-form";

const LTPSummary = forwardRef(({ formData, applicationDocs, ref, isEmployee = true, setDeclarationChecked }) => {
  const owners = formData?.tradeLicenseDetail?.owners?.[0];
  const { t } = useTranslation();
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const filteredDocuments = applicationDocs?.filter((doc) => !["applicantPhoto", "signature", "paymentReciept"].includes(doc.documentType));
  const paymentReciept = applicationDocs?.filter((doc) => ["paymentReciept"].includes(doc.documentType))?.[0]?.fileStoreId;
  const calculationObj = formData?.calculation?.taxHeadEstimates?.[0];
  const urlImg = "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg";
  const nameOfDepartment = "AWAS EVAM VIKAS PARISHAD";
  const nameOfAuthority = "DEVELOPMENT AUTHORITY";
  const department = formData?.department === "AVP" ? nameOfDepartment : nameOfAuthority;
  const paymentDetails = formData?.fee;
  const tradeUnits = formData?.tradeLicenseDetail?.tradeUnits;
  const tradeType = tradeUnits?.[0]?.tradeType;
  const formatDate = (dob) => {
    if (!dob) return "N/A";
    let dateOfBirth = dob.toString();
    const year = dateOfBirth?.substring(0, 4);
    const month = dateOfBirth?.substring(4, 6);
    const day = dateOfBirth?.substring(6, 8);
    return `${day}/${month}/${year}`;
  };
  const convertdate = (date) => {
    return date?.split("-")?.reverse()?.join("/");
  };
  const handleDeclarationChange = (event) => {
    setDeclarationChecked(event.target.checked);
  };
  const { control } = useForm({});
  return (
    <div
      style={{
        backgroundColor: "#ffffff",
      }}
      ref={ref}
    >
      <div style={{ display: "flex", padding: "5px", background: "rgb(230, 239, 248)" }}>
        <div style={{ background: "white", borderRadius: "50%" }}>
          <img width="60" height="30" src={urlImg} alt="Uttar-Pradesh-Logo" />
        </div>
        <div style={{ color: "#1f4a7c" }}>
          <p style={{ marginLeft: "12px", fontSize: "1.25rem", fontWeight: "600", fontFamily: '"Calibri", sans-serif' }}>{department}</p>
          <p style={{ marginLeft: "12px", fontFamily: '"Calibri", sans-serif', fontWeight: "500" }}>Government of Uttar Pradesh</p>
        </div>
      </div>
      <div className="groupContainer" style={{ width: "100%", marginTop: "1rem" }}>
        {/* <SummaryCard className="formContainer">
                        <div className="formHeaderContainer">
                        <h2 className="formHeading">{t('Applicant Details')}</h2>
                        </div>
                        <div className="formInputContainer">
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={9}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6}><strong>{`Applicant Type`}</strong></Grid>
                                        <Grid item xs={12} md={6}>{tradeType?.split('.')[0] || "N/A"}</Grid>

                                        <Grid item xs={12} md={6}><strong>{`Applicant Name`}</strong></Grid>
                                        <Grid item xs={12} md={6}>{ `${owners?.initialForApplicantName +' '+ owners?.name}` || "N/A"}</Grid>

                                        <Grid item xs={12} md={6}><strong>{`Educational Qualification`}</strong></Grid>
                                        <Grid item xs={12} md={6}>{owners?.qualification || "N/A"}</Grid>

                                        <Grid item xs={12} md={6}><strong>{`Name of Firm`}</strong></Grid>
                                        <Grid item xs={12} md={6}>{owners?.firmName || "N/A"}</Grid>

                                        <Grid item xs={12} md={6}><strong>{`Pan Number`}</strong></Grid>
                                        <Grid item xs={12} md={6}>{owners?.pan || "N/A"}</Grid>

                                        <Grid item xs={12} md={6}><strong>{`Total Experience (in Years)`}</strong></Grid>
                                        <Grid item xs={12} md={6}>{owners?.totalExperience || "N/A"}</Grid>

                                       

                                        <Grid item xs={12} md={6}><strong>{`Aadhaar Number`}</strong></Grid>
                                        <Grid item xs={12} md={6}>{owners?.aadhaarNumber || "N/A"}</Grid>

                                        <Grid item xs={12} md={6}><strong>{`Date of Birth`}</strong></Grid>
                                        <Grid item xs={12} md={6}>{owners?.dob ? formatDate(owners?.dob) : "N/A"}</Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            {owners?.photo ? (
                                                <img style={{ width: "250px", height: "250px" }} src={owners?.photo} alt={'image'} className="img-thumbnail" />
                                            ) : (
                                                <Avatar style={{ width: "70px", height: "70px" }}>{item?.photo}</Avatar>
                                            )}
                                           
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </div>
                    </SummaryCard> */}
        <SummaryCard className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Applicant Details")}</h2>
          </div>

          <React.Fragment>
            <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ width: "100%" }}>
                <div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "wrap",
                      marginTop: "15px",
                      marginBottom: "15px",

                      paddingBottom: "15px",
                    }}
                  >
                    {/*  */}
                    <div style={{ flex: "1 1 calc(50% - 10px)", marginRight: "10px" }}>
                      <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <tbody>
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>Application No.</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{formData?.applicationNumber || "N/A"}</td>
                          </tr>
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>Applicant Type:</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{formData?.registrationType || "N/A"}</td>
                          </tr>

                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>Applicant Name:</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{`${owners?.initialForApplicantName + " " + owners?.name}` || "N/A"}</td>
                          </tr>

                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>Educational Qualification:</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{owners?.qualification || "N/A"}</td>
                          </tr>
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>Name of Firm:</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{owners?.firmName || "N/A"}</td>
                          </tr>

                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>Pan Number:</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{owners?.pan || "N/A"}</td>
                          </tr>
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>Total Experience (in Years):</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{owners?.totalExperience || "N/A"}</td>
                          </tr>
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>Aadhaar Number:</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{owners?.aadhaarNumber || "N/A"}</td>
                          </tr>
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>Date of Birth:</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{owners?.dob ? formatDate(owners?.dob) : "N/A"}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    {owners?.photo && (
                      <div
                        style={{
                          flex: "1 1 calc(50% - 10px)",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-around",
                          alignItems: "center",
                        }}
                      >
                        <div className="row" style={{ marginBottom: "10px" }}>
                          {owners?.photo ? (
                            <img
                              style={{ width: "200px", height: "250px", objectFit: "cover" }}
                              src={owners?.photo}
                              alt={"image"}
                              className="img-thumbnail"
                            />
                          ) : (
                            <Avatar style={{ width: "200px", height: "80px" }}>{owners?.photo}</Avatar>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        </SummaryCard>
        {/* <SummaryCard className="formContainer">
                        <div className="formHeaderContainer">
                            <h2 className="formHeading">{t('Contact Information')}</h2>
                        </div>
                        <div className="formInputContainer">
                        <Grid container spacing={2}>
                                <Grid item xs={12} md={6}><strong>{`Address`}</strong></Grid>
                                <Grid item xs={12} md={6}>{owners?.permanentAddress?.address || "N/A"}</Grid>
                                <Grid item xs={12} md={6}><strong>{`District`}</strong></Grid>
                                <Grid item xs={12} md={6}>{owners?.permanentAddress?.district || "N/A"}</Grid>
                                <Grid item xs={12} md={6}><strong>{`Mobile No.`}</strong></Grid>
                                <Grid item xs={12} md={6}>{owners?.mobileNumber || "N/A"}</Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}><strong>{`State`}</strong></Grid>
                                <Grid item xs={12} md={6}>{owners?.permanentAddress?.state || "N/A"}</Grid>
                                <Grid item xs={12} md={6}><strong>{`Pincode`}</strong></Grid>
                                <Grid item xs={12} md={6}>{owners?.permanentAddress?.pinNo || "N/A"}</Grid>
                                <Grid item xs={12} md={6}><strong>{`Email ID`}</strong></Grid>
                                <Grid item xs={12} md={6}>{owners?.emailId || "N/A"}</Grid>
                                <Grid item xs={12} md={6}><strong>{`Nationality`}</strong></Grid>
                                <Grid item xs={12} md={6}>{owners?.nationality || "Indian"}</Grid>
                            </Grid>
                        </div>
                    </SummaryCard> */}

        <SummaryCard className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Contact Information")}</h2>
          </div>
          <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ width: "100%" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>Address:</b>
                    </td>
                    <td style={{ width: "50%", padding: "8px" }}>{owners?.permanentAddress?.address || "N/A"}</td>
                  </tr>

                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>District:</b>
                    </td>
                    <td style={{ width: "50%", padding: "8px" }}>{owners?.permanentAddress?.district || "N/A"}</td>
                  </tr>

                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>State:</b>
                    </td>
                    <td style={{ width: "50%", padding: "8px" }}>{owners?.permanentAddress?.state || "N/A"}</td>
                  </tr>

                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>Pincode:</b>
                    </td>
                    <td style={{ width: "50%", padding: "8px" }}>{owners?.permanentAddress?.pinNo || "N/A"}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>Email ID:</b>
                    </td>
                    <td style={{ width: "50%", padding: "8px" }}>{owners?.emailId || "N/A"}</td>
                  </tr>

                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>Nationality:</b>
                    </td>
                    <td style={{ width: "50%", padding: "8px" }}>{owners?.nationality || "Indian"}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </SummaryCard>
        {/* <SummaryCard className="formContainer">
                        <div className="formHeaderContainer">
                        <h2 className="formHeading">{t('Registration Details')}</h2>
                        </div>
                        <div className="formInputContainer">
                        <Grid container spacing={2}>
                               <Grid item xs={12} md={6}><strong>{`Id Proof Type`}</strong></Grid>
                                 <Grid item xs={12} md={6}>{formData?.idProofType || "N/A"}</Grid>
                                <Grid item xs={12} md={6}><strong>{`Valid Upto`}</strong></Grid>
                                 <Grid item xs={12} md={6}>{convertdate(formData?.validupto) || "N/A"}</Grid>
                             </Grid>
                             <Grid container spacing={2}>
                                 <Grid item xs={12} md={6}><strong>{`Certificate No. (For Minimum Qualification)`}</strong></Grid>
                                 <Grid item xs={12} md={6}>{owners?.architectureNo || "N/A"}</Grid>
                                 <Grid item xs={12} md={6}><strong>{`Verifying Authority`}</strong></Grid>
                                 <Grid item xs={12} md={6}>{formData?.authorityName || "N/A"}</Grid>
                             </Grid>
                        </div>
                    </SummaryCard> */}

        <SummaryCard className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Registration Details")}</h2>
          </div>
          <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ width: "100%" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>Id Proof Type:</b>
                    </td>
                    <td style={{ width: "50%", padding: "8px" }}>{formData?.idProofType || "N/A"}</td>
                  </tr>

                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>Valid Upto:</b>
                    </td>
                    <td style={{ width: "50%", padding: "8px" }}>{convertdate(formData?.validupto) || "N/A"}</td>
                  </tr>

                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>Certificate No. (For Minimum Qualification):</b>
                    </td>
                    <td style={{ width: "50%", padding: "8px" }}>{owners?.architectureNo || "N/A"}</td>
                  </tr>

                  <tr>
                    <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                      <b>Verifying Authority:</b>
                    </td>
                    <td style={{ width: "50%", padding: "8px" }}>{formData?.authorityName || "N/A"}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </SummaryCard>
        <SummaryCard className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Document Details")}</h2>
          </div>
          <div className="formInputContainer">
            <Grid container spacing={2}>
              {filteredDocuments?.map((document, index) => {
                const documentType = document?.documentType?.charAt(0).toUpperCase() + document?.documentType?.slice(1);
                return (
                  <Grid item xs={12} md={6} key={index}>
                    {" "}
                    {/* Two items per row on medium screens and above */}
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <strong>{documentType} </strong>:
                      </Grid>{" "}
                      {/* Label part */}
                      <Grid item xs={6}>
                        <FaFilePdf
                          color="#a10505"
                          style={{ width: "20px", height: "30px" }}
                          onClick={() => getDocumentByFileStoreId(document?.fileStoreId, setIsPreviewLoading)}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
          </div>
        </SummaryCard>

        {/* {tradeType !== 'ARCHITECT.CLASSA' && <SummaryCard className="formContainer">
                        <div className="formHeaderContainer">
                        <h2 className="formHeading">{t('Payment Details')}</h2>
                        </div>
                        <div className="formInputContainer">
                             <Grid container spacing={2}>
                                 <Grid item xs={12} md={6}><strong>{`Payment Mode`}</strong></Grid>
                                 <Grid item xs={12} md={6}>{paymentDetails?.paymentmode || "N/A"}</Grid>
                                 <Grid item xs={12} md={6}><strong>{`UTR No. / Transaction Number`}</strong></Grid>
                                 <Grid item xs={12} md={6}>{paymentDetails?.utrNo || "N/A"}</Grid>
                             </Grid>
                             <Grid container spacing={2}>
                                 <Grid item xs={12} md={6}><strong>{`Bank-Name`}</strong></Grid>
                                 <Grid item xs={12} md={6}>{paymentDetails?.bankName || "N/A"}</Grid>
                                 <Grid item xs={12} md={6}><strong>{`Payment Reciept`}</strong></Grid>
                                 <Grid item xs={12} md={6}>
                                    <FaFilePdf
                                         color="#a10505"
                                         style={{ width: '20px', height: '30px' }}
                                         onClick={() => getDocumentByFileStoreId(paymentReciept, setIsPreviewLoading)}
                                     />
                                 </Grid>
                             </Grid>
                         </div>
                    </SummaryCard>} */}
        {/* 
                    {tradeType !== 'ARCHITECT.CLASSA' && <SummaryCard className="formContainer">
                        <div className="formHeaderContainer">
                        <h2 className="formHeading">{t('Fee Details')}</h2>
                        </div>
                        <div className="formInputContainer">
                             <Grid container spacing={2}>
                                 <Grid item xs={12} md={6}><strong>{`Registration Amount`}</strong></Grid>
                                 <Grid item xs={12} md={6}>{`₹ ${calculationObj?.registrationFee}`}</Grid>
                                 <Grid item xs={12} md={6}><strong>{`Total Fee`}</strong></Grid>
                                 <Grid item xs={12} md={6}>{`₹ ${calculationObj?.estimateAmount}`}</Grid>
                             </Grid>
                             <Grid container spacing={2}>
                                 <Grid item xs={12} md={6}><strong>{`GST Amount (18%)`}</strong></Grid>
                                 <Grid item xs={12} md={6}>{`₹ ${calculationObj?.gst}`}</Grid>
                             </Grid>
                         </div>
                    </SummaryCard>} */}

        {tradeType !== "ARCHITECT.CLASSA" && (
          <SummaryCard className="formContainer">
            <div className="formHeaderContainer">
              <h2 className="formHeading">{t("Fee Details")}</h2>
            </div>
            <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ width: "100%" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Registration Amount:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{`₹ ${calculationObj?.registrationFee}`}</td>
                    </tr>

                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>GST Amount (18%):</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{`₹ ${calculationObj?.gst}`}</td>
                    </tr>

                    <tr>
                      <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                        <b>Total Fee:</b>
                      </td>
                      <td style={{ width: "50%", padding: "8px" }}>{`₹ ${calculationObj?.estimateAmount}`}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </SummaryCard>
        )}
        {!isEmployee && (
          <div className="formContainer">
            <FormControlLabel
              style={{ padding: "10px 15px" }}
              control={
                <Checkbox
                  name="declaration"
                  control={control}
                  onChange={handleDeclarationChange}
                  rules={{ required: "You must agree to the terms and conditions" }}
                />
              }
              label={
                <span style={{ whiteSpace: "normal", wordBreak: "break-word", display: "flex", flexWrap: "wrap" }}>
                  <p>This project is based on the inputs and documents provided by the Licensed Technical Person (LTP).</p>
                  <br />
                  <p>It is entirely reliant on the trust and verification conducted by the LTP.</p>
                </span>
              }
            />
          </div>
        )}
      </div>
    </div>
  );
});
export default LTPSummary;
